<template>
  <div class="stats-card">
    <div class="card-content">
      <div class="card-info">
        <div class="card-title">{{ title }}</div>
        <div class="card-value text-center">{{ value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatsCard',
  props: {
    title: {
      type: String,
      default: 'Total Users',
    },
    value: {
      type: Number,
      required: true,
    },
    change: {
      type: Number,
      required: true,
    },
    iconColor: {
      type: String,
      default: 'blue',
      validator: (value) => ['blue', 'green', 'red', 'orange', 'purple'].includes(value),
    },
  },
};
</script>
<style>
.title {
  font-size: 24px;
  font-weight: bold;
  color: #111827;
  margin-bottom: 24px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
}

.stats-card {
  background: white;
  border-radius: 8px;
  padding: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  transition: box-shadow 0.2s ease;
}

.stats-card:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.card-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.card-info {
  flex: 1;
}

.card-title {
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  margin-bottom: 4px;
}

.card-value {
  font-size: 30px;
  font-weight: bold;
  color: #111827;
  margin-bottom: 8px;
}

.card-change {
  display: flex;
  align-items: center;
  gap: 4px;
}

.change-value {
  font-size: 14px;
  font-weight: 500;
}

.change-positive {
  color: #059669;
}

.change-negative {
  color: #dc2626;
}

.change-label {
  font-size: 12px;
  color: #6b7280;
}

.card-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.icon-blue {
  background-color: #dbeafe;
  color: #2563eb;
}

.icon-green {
  background-color: #d1fae5;
  color: #059669;
}

.icon-purple {
  background-color: #e9d5ff;
  color: #7c3aed;
}

.icon-orange {
  background-color: #fed7aa;
  color: #ea580c;
}

.icon {
  width: 24px;
  height: 24px;
  stroke: currentColor;
  stroke-width: 2;
  fill: none;
}

@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }

  body {
    padding: 16px;
  }
}
</style>
